export default class AdminService {
  constructor(Restangular) {
    'ngInject';
    this.Restangular = Restangular
    this.USER_SERVICE = "users";
    this.MANAGING_ORG_SERVICE = "managing_orgs";
  }

  makeDistributor(name, adminEmail) {
    let payload = {
      name,
      adminEmail
    };

    let promise = this.Restangular.oneUrl(this.MANAGING_ORG_SERVICE, `${process.env.__backendUrl__}/internal/v1/managing_orgs`).customPOST(payload);
    return promise;
  }

  addUserToDistributor(userEmail, managingOrg, managingOrgAdmin) {
    let payload = {
      userEmail,
      managingOrg,
      managingOrgAdmin
    };

    let promise = this.Restangular.oneUrl(this.USER_SERVICE, `${process.env.__backendUrl__}/internal/v1/users`).customPOST(payload);
    return promise;
  }

  getUsersOfDistributor(managingOrgId) {
    let promise = this.Restangular.oneUrl(this.MANAGING_ORG_SERVICE,
      `${process.env.__backendUrl__}/internal/v1/managing_orgs/${managingOrgId}/users`).get();
    return promise;
  }

  getAllDistributors() {
    let promise = this.Restangular.oneUrl(this.MANAGING_ORG_SERVICE, `${process.env.__backendUrl__}/internal/v1/managing_orgs`).get();
    return promise;
  }
}


